import Button from "components/core/Button/Button";
import React from "react";
import styles from "./PopularPerkCard.module.scss";

type Props = {
  title: string;
  tickerSymbol: string;
  imageUrl: string;
  logoUrl: string;
  availableToClaim?: boolean;
  onClick: () => void;
};

const PopularPerkCard = (props: Props) => {
  return (
    // <Link
    //   key={`popular-perk-${props.tickerSymbol}`}
    //   href={`/brand/${props.tickerSymbol}`}
    // >
    //   <a>
    <div
      className={styles.card}
      style={{
        backgroundImage: `url(https:${props.imageUrl})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      onClick={props.onClick}
    >
      <div className={styles.blueOverlay} />
      <div className={styles.cardDetail}>
        <div className={styles.mostPopular}>Most Popular</div>
        <div className={styles.detailContainer}>
          <div className={styles.logoContainer}>
            <img src={props.logoUrl} className={styles.brandLogo} />
            {props.availableToClaim && (
              <div className={styles.availableToClaim}>Available to claim</div>
            )}
          </div>

          <h2 className={styles.title}>{props.title}</h2>

          <Button
            type="inline"
            arrow
            noAnimate
            className={styles.button}
            submit={true}
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
    //   </a>
    // </Link>
  );
};

export default PopularPerkCard;
